// Add has-inner-banner class to the body if .inner-banner class exists
document.addEventListener("DOMContentLoaded", function () {
  var innerBanner = document.querySelector(".innr-bnnr-main");
  if (innerBanner) {
    document.body.classList.add("has-inner-banner");
  }
});

// Custom order modal
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    if (e.target.matches(".custom-order-button")) {
      const sectionId = e.target.dataset.section;
      const modal = document.getElementById(e.target.dataset.modalTarget);
      const optionsInput = document.getElementById("custom-order-options-" + sectionId);
      const summaryList = document.getElementById("custom-order-summary-" + sectionId);
      const form = document.getElementById("custom-order-form-" + sectionId);
      if (modal) {
        if (optionsInput) {
          const selectedValues = [];

          function addHiddenField(label, value) {
            if (!form) return;
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = "contact[" + label.toLowerCase().replace(/\s+/g, "_") + "]";
            input.value = value;
            input.classList.add("custom-order-cloned-option");
            form.appendChild(input);
          }

          if (form) {
            form
              .querySelectorAll(".custom-order-cloned-option")
              .forEach((el) => el.remove());
          }
          // Get standard variant options
          document
            .querySelectorAll("#variant-selects-" + sectionId + " [data-selected-value]")
            .forEach(function (el) {
              const label = el
                .closest("fieldset,div")
                .querySelector("legend,label")
                .textContent.trim();
              const value = el.textContent.trim();
              selectedValues.push(label + ": " + value);
              addHiddenField(label, value);
            });

          // Get attached app options (e.g. GPO)
          const sectionEl = document.getElementById("shopify-section-" + sectionId);
          if (sectionEl) {
            sectionEl
              .querySelectorAll(
                ".gpo-container input, .gpo-container select, .gpo-container textarea"
              )
              .forEach(function (input) {
                let labelText = "";
                const wrapper = input.closest(
                  ".gpo-element, .gpo-form__group, .gpo-field"
                );
                const label = wrapper &&
                  wrapper.querySelector(
                    ".gpo-label .label-content, .gpo-label, label"
                  );
                if (label) {
                  labelText = label.textContent.trim();
                }

                let value = "";
                if (input.tagName === "SELECT") {
                  value = input.selectedOptions.length
                    ? input.selectedOptions[0].textContent.trim()
                    : "";
                } else if (input.type === "checkbox" || input.type === "radio") {
                  if (!input.checked) return;
                  if (input.nextElementSibling && input.nextElementSibling.matches("label")) {
                    value = input.nextElementSibling.textContent.trim();
                  } else {
                    value = input.value;
                  }
                } else {
                  value = input.value.trim();
                }

                if (value) {
                  const labelForDisplay = labelText || input.name;
                  selectedValues.push(labelForDisplay + ": " + value);
                  addHiddenField(labelForDisplay, value);
                }
              });
          }

          optionsInput.value = selectedValues.join(", ");
          if (summaryList) {
            summaryList.innerHTML = selectedValues
              .map(function (val) {
                return "<li>" + val + "</li>";
              })
              .join("");
          }
        }
        modal.classList.remove("hidden");
      }
    }
    if (e.target.matches(".custom-order-close")) {
      const modal = e.target.closest(".custom-order-modal");
      if (modal) {
        modal.classList.add("hidden");
      }
    }
  });
});

// Get Header Height
function updateHeaderwrapHeight() {
  const headerWrap = document.querySelector(".header-wrapper");
  if (headerWrap) {
    const height = headerWrap.offsetHeight;
    document.documentElement.style.setProperty(
      "--headerwrap-height",
      `${height}px`
    );
  }
}
document.addEventListener("DOMContentLoaded", function () {
  updateHeaderwrapHeight();
  window.addEventListener("resize", updateHeaderwrapHeight);
});

// Get announcement bar Height
function updateAnnounceBarHeight() {
  const announceBar = document.querySelector(".utility-bar");
  if (announceBar) {
    const height = announceBar.offsetHeight;
    document.documentElement.style.setProperty(
      "--announcebar-height",
      `${height}px`
    );
  }
}
document.addEventListener("DOMContentLoaded", function () {
  updateAnnounceBarHeight();
  window.addEventListener("resize", updateAnnounceBarHeight);
});

// Blank in the wild slider script
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".image-card-slider", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      481: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
    },
  });
});

// marquee slider script start
document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("marqueeTrack");
  if (!track) return;

  let position = 0;
  let isPaused = false;
  const speedSetting = Number(track.dataset.speed);
  const scrollSpeed = Number.isNaN(speedSetting) ? 1 : speedSetting;

  // Clone content for seamless loop
  track.innerHTML += track.innerHTML;

  function animate() {
    if (!isPaused) {
      position -= scrollSpeed; // Change this number to control speed
      if (Math.abs(position) >= track.scrollWidth / 2) {
        position = 0;
      }
      track.style.transform = `translateX(${position}px)`;
    }
    requestAnimationFrame(animate);
  }

  // Hover events
  track.parentElement.addEventListener("mouseenter", () => (isPaused = true));
  track.parentElement.addEventListener("mouseleave", () => (isPaused = false));

  animate();
});

// announcement bar marquee
document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("announcementBarTrack");
  if (!track) return;

  let position = 0;
  let isPaused = false;

  // Clone content for seamless loop
  track.innerHTML += track.innerHTML;

  function animate() {
    if (!isPaused) {
      position -= 1; // Change this number to control speed
      if (Math.abs(position) >= track.scrollWidth / 2) {
        position = 0;
      }
      track.style.transform = `translateX(${position}px)`;
    }
    requestAnimationFrame(animate);
  }

  // Hover events
  track.parentElement.addEventListener("mouseenter", () => (isPaused = true));
  track.parentElement.addEventListener("mouseleave", () => (isPaused = false));

  animate();
});

document.addEventListener('DOMContentLoaded', function() {
  const targetContainer = document.getElementById('modal-article-content');
  const modalCloseButton = document.querySelector('.modal-close');

  document.addEventListener('click', function(e) {
    if (e.target.matches('a.article-popup-link')) {
      e.preventDefault();

      const url = e.target.dataset.articleUrl;
      if (!targetContainer || !url) return;

      document.body.classList.add('modal-open'); 
      targetContainer.classList.remove('hidden'); 
      targetContainer.innerHTML = 'Loading...';

      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const articleTemplate = doc.querySelector('.article-template');

          if (articleTemplate) {
            targetContainer.innerHTML = articleTemplate.outerHTML;
          } else {
            targetContainer.innerHTML = '<p>Article content not found.</p>';
          }
        })
        .catch(error => {
          console.error('Fetch error:', error);
          targetContainer.innerHTML = '<p>Failed to load content.</p>';
        });
    }

    // Close modal on background or close button click
    if (e.target === targetContainer || e.target === modalCloseButton) {
      closeModal();
    }
  });

  // ESC to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  function closeModal() {
    if (targetContainer) targetContainer.classList.add('hidden');
    if (targetContainer) targetContainer.innerHTML = '';
    document.body.classList.remove('modal-open'); 
  }
});
